// projects/humanresources-personnel/src/assets/i18n/*/hr-per-award.json
export class HrPerAwardKey {
    private static readonly keyPrefix = 'hrPerAward';
    public static title = `${HrPerAwardKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerAwardKey.keyPrefix}.pageHeader`;
    public static authorityId = `${HrPerAwardKey.keyPrefix}.authorityId`;
    public static typeId = `${HrPerAwardKey.keyPrefix}.typeId`;
    public static reasonForAward = `${HrPerAwardKey.keyPrefix}.reasonForAward`;
    public static documentNumber = `${HrPerAwardKey.keyPrefix}.documentNumber`;
    public static documentDate = `${HrPerAwardKey.keyPrefix}.documentDate`;
    public static amount = `${HrPerAwardKey.keyPrefix}.amount`;
    public static genCurrencyUuid = `${HrPerAwardKey.keyPrefix}.genCurrencyUuid`;
    public static dataApprovalStatus = `${HrPerAwardKey.keyPrefix}.dataApprovalStatus`;
}
